import "css/formDISharedResponsive.css";
import React, {  useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next"   
import { ENDPOINT } from "constants/variables"; 
import Box from '@mui/material/Box';    
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container'; 
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import TableSortingViewsShared from "pages/forms/filterFormDI/SortingTablesFormDIShared";
import PropTypes from 'prop-types';
  
const initialStateStore = [{
  "id" : 0, 
  "documentid":0,
  "tradename" : "",
  "name" : "" 
}];   

const FormDIShared = ({ openSharedRowFormDI, setOpenSharedRowFormDI,rowEditFormDI}) => {
  const {t,i18n} = useTranslation(['listDataForms']);
  const token = useSelector((state) => state.loginUser.token); 
  const [dataShared, setDataShared] = useState(initialStateStore);
  const [isLoadingErrorShared, setIsLoadingErrorShared] = useState(false);
  const isLoading = useSelector((state) => state.loading.isLoading);   
  const dispatch = useDispatch(); 
   
  const handleCloseDataViewShared = () => {
    setDataShared(initialStateStore);
    setIsLoadingErrorShared(false);
    dispatch(setLoading(false)); 
    setOpenSharedRowFormDI(false)
	};
   
  useEffect(() => {
    const fetchdataShared = async () => {
      try {
        dispatch(setLoading(false));
        const getData = await helpHttp().get11(ENDPOINT,`form/getformidsharedby`,token,rowEditFormDI.id);
        if (getData.err) {
          dispatch(setLoading(false));
          setDataShared(initialStateStore);
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else {
          setDataShared(getData);
          dispatch(setLoading(false)); 
        } 
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    }; 
    
    if (openSharedRowFormDI){  
      fetchdataShared();
    }
    return () => { };
  }, [t,i18n,token,dispatch,openSharedRowFormDI,rowEditFormDI.id]);
  
  const toggleDrawerSearchFormDI  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataViewShared();
    }
  };

  return(
    <>
      {openSharedRowFormDI && 
        <div>
          <SwipeableDrawer
            PaperProps={{ className: 'formdi-shared-panel' }}
            anchor='right'
            open={true}
            onClose={toggleDrawerSearchFormDI(false)}
            onOpen={toggleDrawerSearchFormDI(true)}>
            <Container >
              <Box sx={{ bgcolor: '#ffffff', width: '100%', minWidth: 0, maxWidth: '100%'}}>
                <div className="formdi-pending-header2"> 
                  <h1 className="formdi-pending-title">
                  {isLoadingErrorShared?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoading?<CircularProgress color={"primary"}/>:<i className="fas fa-regular fa-clipboard text-warning"></i>} {t('Text_FORM_NUM_DI')+": "+rowEditFormDI.ownformdi_id}</h1>
                    <div>
                      <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={handleCloseDataViewShared} >{t('Button_Back')}</button><> </>
                    </div> 
                </div>  
                <br/>  
                {!isLoading ?
                  <>
                    <div className="formdi-pending-card-flat">
                      <div className="formdi-pending-card-content">
                        <TableSortingViewsShared
                          dataShared={dataShared} 
                          titleTable={"Text_Share_Form_With"} 
                        >
                      </TableSortingViewsShared>
                      </div>             
                    </div>
                     
                  {/* End Content Row */}
                  </>:
                    <LoadingNews/>
                } 
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

FormDIShared.propTypes = {
  openSharedRowFormDI: PropTypes.bool.isRequired,
  setOpenSharedRowFormDI: PropTypes.func.isRequired 
};

export default FormDIShared;

